import Vue from 'vue'
import Vuex from 'vuex'
import BookingConfirmedCollection from "@/collections/bookingConfirmedCollection";
import ServiceDeliveryFormCollection from "@/collections/serviceDeliveryFormCollection"
import InterpreterJobActivityModel from "@/models/interpreterJobActivityModel"

Vue.use(Vuex);


const getDefaultState = () => {
	return {
		bookingConfirmedCollection: new BookingConfirmedCollection(),
		serviceDeliveryFormCollection: new ServiceDeliveryFormCollection(),
		interpreterJobActivityModel: new InterpreterJobActivityModel(),
		bookings: {
			confirmed: ''
		},
		bookingDetail: {
			ref_num: '',
			jobSessionId: 0
		},
		route: {
			name: ''
		},
		jwt: localStorage.getItem("jwt"),
		profile: {
			interpreterId: localStorage.getItem("interpreterId"),
			first_name: localStorage.getItem('interpreterFirstName'),
			surname: localStorage.getItem('interpreterLastName'),
			mobile: localStorage.getItem('interpreterMobile'),
			phone: localStorage.getItem('interpreterPhone')
		},
		sideNav: {
			active: false
		},
		availability: {
			show: false
		},
		clock: {
			on: false,
			off: false,
			hide: false,
			messageArray: []
		},
		clockOnHide: false,
		acceptDeclineHide: true,
		availUnavailableHide: true,
		camera: {
			status: false,
			hide: false
		},
		search: {
			status: false,
			hide: false,
			popup: false
		},
		resourceCategory: {
			status: false,
			hide: false,
			popup: false
		},
		jobSlips: {
			uploaded: false
		},
		icon: {
			slot: []
		},
		imageFor: 'jobSlips',
		noEndDate: 0,
		job: {
			ref_num: 0
		},
		button: {
			back: false
		},
		returnToComp: '',
		scrollStatus: false,
		clockActivity: false,
		strDate: [],
		callToOffice: [],
		intervalVariable: [],
		isInterval: false,
		searchedDate: '',
		inter_trans: '',
		serviceDate: '',
		serviceStartTime: '',
		serviceEndTime: ''
	}
};

// initial state
const state = getDefaultState();

const actions = {
	toggleSideNav(context, active) {
		context.commit('toggleSideNav', active)
	},
	updateProfile(context, profile) {
		context.commit('updateProfile', profile);
	},
	resetState(context) {
		console.log('reset');
		context.commit('resetState')
	},
	updateToken(context, token) {
		context.commit('updateToken', token)
	},
	updateAvailability(context, active) {
		context.commit('updateAvailability', active);
	},
	updateClockOnOff(context, clockedOn) {
		context.commit('updateClockOnOff', clockedOn);
	},
	updateClockOnHide(context, clockedOn) {
		context.commit('updateClockOnHide', clockedOn);
	},
	availableBooking(context, state) {
		context.commit('availableBooking', state);
	},
	updateCameraState(context, status) {
		context.commit('updateCameraState', status);
	},
	updateCameraStateHide(context, status) {
		context.commit('updateCameraStateHide', status);
	},
	updateSearchState(context, status) {
		context.commit('updateSearchState', status);
	},
	updateSearchStateHide(context, status) {
		context.commit('updateSearchStateHide', status);
	},
	updateResourceCategory(context, status) {
		context.commit('updateResourceCategory', status);
	},
	updateResourceCategoryHide(context, status) {
		context.commit('updateResourceCategoryHide', status);
	},
	updateSearchPopUpShow(context, status) {
		context.commit('updateSearchPopUpShow', status);
	},
	updateBookingsConfirmed(context, status) {
		context.commit('updateBookingsConfirmed', status);
	},
	updateClockOnOffHide(context, status) {
		context.commit('updateClockOnOffHide', status);
	},
	updateAcceptDeclineHide(context, status) {
		context.commit('acceptDeclineHide', status);
	},
	updateAvailUnavailableHide(context, status) {
		context.commit('availUnavailableHide', status);
	},
	updateBookingDetailRefNum(context, status) {
		context.commit('updateBookingDetailRefNum', status);
	},
	updateJobSessionId(context, status) {
		context.commit('updateJobSessionId', status);
	},
	highlightJob(context, status) {
		context.commit('highlightJob', status);
	},
	updateIcon(context, iconArray) {
		context.commit('updateIcon', iconArray);
	},
	updateJobMatchingConditions(context, jobModelObj) {
		let jobModelObjectKey = jobModelObj[0];
		let jobModelObject = jobModelObj[1];

		/** Condition 1: Checking if job is owned by Interpreter **/
		if (context.getters.isBookingsConfirmed) {

			let interpreterActivityId = jobModelObject.activity_type_id;
			context.dispatch('updateInterpreterActivities', interpreterActivityId);
			// /** activity_type_id 9 means Clocked On whereas 10 means Clocked Off **/
			// if (interpreterActivityId == 9) {
			// 	context.commit('updateClockOnOff', false);
			// }
			// else if (interpreterActivityId == 10) {
			// 	context.commit('updateClockOnOffDisable', true);
			// }

			// let strDateStart = jobModelObject.service_date + ' ' + jobModelObject.service_time_start;
			// let strDateEnd = jobModelObject.service_date + ' ' + jobModelObject.service_time_end;


			let strDateStart = jobModelObject.service_date_safari + ' ' + jobModelObject.start_safari;
			let strDateEnd = jobModelObject.service_date_safari + ' ' + jobModelObject.end_safari;

			context.commit('updateStrDate', [jobModelObject.ref_num, strDateStart, strDateEnd]);

			let dateTimeStart = (Date.parse(strDateStart) / 1000).toFixed();
			const dateObjN = new Date();
			let dateNow = (dateObjN / 1000).toFixed();

			/** Condition 2: Job must be past datetime **/

			context.dispatch('checkJobIsPastOrFuture', [dateNow, dateTimeStart, interpreterActivityId, jobModelObject.ref_num, jobModelObjectKey]);
		}

		return new Promise((resolve) => {
			resolve();
		});
	},
	updateInterpreterActivities(context, interpreterActivityId) {
		/** activity_type_id 9 means Clocked On whereas 10 means Clocked Off **/
		if (interpreterActivityId == 9) {
			context.commit('updateClockOnOff', false);
		}
		else if (interpreterActivityId == 10) {
			context.commit('updateClockOnOffDisable', true);
		}
		else {
			context.commit('updateClockOnOff', true);
		}
	},
	checkJobIsPastOrFuture(context, object) {
		let dateNow = object[0];
		let dateTimeStart = object[1];
		let interpreterActivityId = object[2];
		let ref_num = object[3];
		let key = object[4];
		let isPast = false;

		if (dateNow > dateTimeStart) {
			console.log('Is Past Job');
			isPast = true;
		}
		else {
			console.log('Is Future Job');
		}

		context.dispatch('checkIfJobWithIn30Mins', [interpreterActivityId, ref_num, isPast, key]);
		context.commit('updateIsInterval', false);

		context.getters.getIntervalVariable.push(setInterval(function () {
			console.log('checkJobIsPastOrFuture setInterval');
			console.log(ref_num);
			context.commit('updateIsInterval', true);
			context.dispatch('checkIfJobWithIn30Mins', [interpreterActivityId, ref_num, isPast, key]);
		}, 60000))
	},
	checkIfJobWithIn30Mins(context, object) {

		const dateObjN = new Date();
		let dateNow = (dateObjN / 1000).toFixed();
		let interpreterActivityId = object[0];
		let ref_num = object[1];
		let isPast = object[2];
		let key = object[3];

		// console.log(dateNow)
		// console.log(resp)
		// console.log(ref_num)
		// console.log(isPast)
		// console.log('isInterval');
		// console.log(isInterval);
		// console.log('key');
		// console.log(key);

		let plus30 = '';
		let calculatePlusDateTime = context.dispatch('getPlus30FromNow', ref_num);
		calculatePlusDateTime.then(dateTimePlus => {
			plus30 = dateTimePlus;

			/** Actual time start calculation along with datetime conversion and less 30 **/
			const actualDateTimeStart = new Date(context.getters.getStrDateStart(ref_num)[0].start);
			const ADTStart = actualDateTimeStart.setMinutes(actualDateTimeStart.getMinutes());
			const less30 = actualDateTimeStart.setMinutes(actualDateTimeStart.getMinutes() - 30);

			/** Actual time end calculation along with datetime conversion **/
			const actualDateTimeEnd = new Date(context.getters.getStrDateEnd(ref_num)[0].end);
			const ADTEnd = actualDateTimeEnd.setMinutes(actualDateTimeEnd.getMinutes());

			let condition = '';
			if (isPast == true) {
				condition = (plus30 >= dateNow && dateNow >= (ADTStart / 1000).toFixed());
				context.commit('updateCameraState', true);
				context.commit('updateCameraStateHide', false);
				context.commit('updateSearchStateHide', true);
			}
			else {
				condition = (dateNow <= plus30 && dateNow > (less30 / 1000).toFixed())
			}

			// console.log('Condition');
			// console.log(condition);
			// console.log(plus30);
			// console.log((less30 / 1000).toFixed());
			// console.log(dateNow);
			// console.log((ADTEnd / 1000).toFixed());

			/** Condition 3: Job is starting or was started within 30minutes **/
			if (condition) {
				console.log('Update Clock ON/Off Message Status');
				context.dispatch('updateClockOnOffMessageStatus', [interpreterActivityId, ref_num, key]);
			}
			else {
				console.log('job not within');
				context.dispatch('jobNotWithin', [dateNow, (ADTEnd / 1000).toFixed(), ref_num, (ADTStart / 1000).toFixed(), key, interpreterActivityId]);
			}

			console.log('');
			console.log('');
		});
	},
	updateClockOnOffMessageStatus(context, object) {
		let interpreterActivityId = object[0];
		let ref_num = object[1];
		let key = object[2];

		if (interpreterActivityId == 9) {
			context.commit('updateClockOnOffMessage', [ref_num, key, 'card-footer-danger', 'Clock Off Required']);
		}
		else if (interpreterActivityId == 10) {
			context.commit('updateClockOnOffMessage', [ref_num, key, 'card-footer-danger', 'Already Clocked Off']);
		}
		else {
			context.commit('updateClockOnOff', true);
			context.commit('updateClockOnOffMessage', [ref_num, key, 'card-footer-green', 'Clock On Required']);
		}
	},
	jobNotWithin(context, object) {

		let dateNow = object[0];
		let ADTEnd = object[1];
		let ref_num = object[2];
		let ADTStart = object[3];
		let key = object[4];
		let interpreterActivityId = object[5];

		// console.log('before if condition');
		// console.log(dateNow);
		// console.log(ADTStart);
		// console.log(ADTEnd);
		// console.log(ref_num);


		context.commit('updateClockOnOffMessage', [ref_num, key, '', '']);

		if (dateNow > ADTEnd) {
			console.log('Time has passed the job end time');
			if ( interpreterActivityId == null ) {
				context.commit('updateClockOnOff', false);
			}
			// context.commit('updateClockOnOffDisable', true);
		}

		if (dateNow > (ADTStart / 1000).toFixed()) {
			console.log('Time has passed the job start time');

			context.dispatch('updateInterpreterActivities', interpreterActivityId);

			if ( interpreterActivityId != 9 && interpreterActivityId == null ){
				console.log('update the popup dialog saying to call the office');
				context.commit('updateCallToOfficePopup', ref_num);
			}
		}
		else {
			context.commit('updateClockOnOffDisable', true);
		}

	},
	getPlus30FromNow(context, ref_num) {

		/** increase 30 mins on service start time **/
		const dateObjP = new Date(context.getters.getStrDateStart(ref_num)[0].start);
		const plus30FromServiceStartTime = dateObjP.setMinutes(dateObjP.getMinutes() + 30);
		const plus30Date = new Date(plus30FromServiceStartTime);

		// console.log('getPlus30FromNow');
		// console.log(ref_num);
		// console.log(dateObjP);
		// console.log(plus30FromServiceStartTime);
		// console.log(plus30Date);
		// console.log((plus30Date / 1000).toFixed());


		return (plus30Date / 1000).toFixed();
	},
	updateImageFor(context, imageFor) {
		context.commit('imageFor', imageFor);
	},
	updateNoEndDate(context, boolean) {
		context.commit('noEndDate', boolean);
	},
	updateJobRefNum(context, refNum = 0) {
		context.commit('jobRefNum', refNum);
	},
	updateBackButton(context, status) {
		context.commit('backButton', status);
	},
	updateReturnToComp(context, name) {
		context.commit('returnToComp', name);
	},
	updateScrollStatus(context, status) {
		context.commit('scrollStatus', status);
	},
	updateJobSlipsStatus(context, status) {
		context.commit('updateJobSlipsStatus', status);
	},
	updateHideAll(context, status = true, array = []) {
		context.commit('updateIcon', array);
		context.commit('updateClockOnOffHide', status);
		context.commit('acceptDeclineHide', status);
		context.commit('availUnavailableHide', status);
		context.commit('updateSearchStateHide', status);
		context.commit('updateCameraStateHide', status);
		context.commit('updateResourceCategoryHide', status);
	},
	clearIntervalVariable(context) {
		context.commit('clearIntervalVariable');
	},
	updateIsInterval(context, status) {
		context.commit('updateIsInterval', status);
	},
	updateInter_trans(context, type) {
		context.commit('updateInter_trans', type);
	},
	updateSearchedDate(context, date) {
		context.commit('updateSearchedDate', date);
	},
	updateServiceDate(context, date) {
		context.commit('updateServiceDate', date);
	},
	updateServiceEndTime(context, time) {
		context.commit('updateServiceEndTime', time);
	},
	updateServiceStartTime(context, time) {
		context.commit('updateServiceStartTime', time);
	}
};

const mutations = {

	toggleSideNav(state, active) {
		state.sideNav.active = active;
	},
	updateProfile(state, profile) {
		console.log('updateProfile : ');
		console.log(profile);
		state.profile.first_name = profile.first_name;
		state.profile.surname = profile.surname;
		state.profile.mobile = profile.mobile;
		state.profile.phone = profile.phone;
		state.profile.interpreterId = profile.interpreter_id;
	},
	updateToken(state, token) {
		state.jwt = token;
	},
	updateAvailability(state, active) {
		state.availability.show = active;
	},
	updateClockOnOff(state, clockedOn) {
		state.clock.on = clockedOn;
		state.clock.off = !clockedOn;
	},
	updateClockOnOffDisable(state, status) {
		state.clock.on = !status;
		state.clock.off = !status;
	},
	updateClockOnOffHide(state, hide) {
		state.clock.hide = hide;
	},
	updateClockOnHide(state, hide) {
		state.clockOnHide = hide;
	},
	updateClockOnOffMessage(state, jobObj) {

		let refNum = jobObj[0];
		let key = jobObj[1];
		let classColor = jobObj[2];
		let message = jobObj[3];

		state.clock.messageArray[key] = {refNum, classColor, message}
	},
	availableBooking(state, status) {
		state.clock.on = state.clock.off = state.camera.status = status;
	},
	updateCameraState(state, status) {
		state.camera.status = status;
	},
	updateCameraStateHide(state, status) {
		state.camera.hide = status;
	},
	updateSearchState(state, status) {
		state.search.status = status;
	},
	updateSearchStateHide(state, status) {
		state.search.hide = status;
	},
	updateResourceCategory(state, status) {
		state.resourceCategory.status = status;
	},
	updateResourceCategoryHide(state, status) {
		state.resourceCategory.hide = status;
	},
	updateSearchPopUpShow(state, status) {
		state.search.popup = status;
	},
	updateBookingsConfirmed(state, status) {
		state.bookings.confirmed = status;
	},
	updateBookingDetailRefNum(state, ref_num) {
		state.bookingDetail.ref_num = ref_num;
	},
	updateJobSessionId(state, jobSessionId = 0) {
		state.bookingDetail.jobSessionId = jobSessionId;
	},
	acceptDeclineHide(state, status) {
		state.acceptDeclineHide = status;
	},
	availUnavailableHide(state, status) {
		state.availUnavailableHide = status;
	},
	checkJobMatchConditions(state, object) {
		state.bookings.confirmed = object[0];
		state.route.name = object[1];
	},
	updateJobSlipsStatus(state, status) {
		state.jobSlips.uploaded = status;
	},
	highlightJob(state, status) {
		state.camera = status;
	},
	updateIcon(state, iconArray) {
		state.icon.slot = iconArray;
	},
	resetState(state) {
		// Merge rather than replace so we don't lose observers
		// https://github.com/vuejs/vuex/issues/1118
		Object.assign(state, getDefaultState())
	},
	imageFor(state, imageFor) {
		state.imageFor = imageFor;
	},
	noEndDate(state, boolean) {
		state.noEndDate = boolean;
	},
	jobRefNum(state, jobRefNum) {
		state.job.ref_num = jobRefNum;
	},
	backButton(state, status) {
		state.button.back = status;
	},
	returnToComp(state, name) {
		state.returnToComp = name;
	},
	scrollStatus(state, status) {
		state.scrollStatus = status;
	},
	updateStrDate(state, strDate) {
		state.strDate.push({ref_num: strDate[0], start: strDate[1], end: strDate[2]});
	},
	updateCallToOfficePopup(state, ref_num) {
		state.callToOffice.push(ref_num);
	},
	updateIsInterval(state, status) {
		state.isInterval = status;
	},
	updateSearchedDate(state, date) {
		state.searchedDate = date;
	},
	updateInter_trans(state, type) {
		state.inter_trans = type;
	},
	updateServiceDate(state, date) {
		state.serviceDate = date;
	},
	updateServiceStartTime(state, time) {
		state.serviceStartTime = time;
	},
	updateServiceEndTime(state, time) {
		state.serviceEndTime = time;
	},
	clearIntervalVariable(state) {
		for (let intervalID of state.intervalVariable) {
			clearInterval(intervalID);
		}

		state.intervalVariable = [];
	}
};

const getters = {
	jwt: state => state.jwt,
	interpreterId: state => state.profile.interpreterId,
	full_name: state => {
		return state.profile.first_name + ' ' + state.profile.surname;
	},
	isAuthenticated: state => {
		if (state.jwt) {
			return true;
		} else {
			return false;
		}
	},
	isClockOnOff: state => {
		return state.clock;
	},
	isClockOnOffHide: state => {
		return state.clock.hide;
	},
	isClockOnHide: state => {
		return state.clockOnHide;
	},
	isCamera: state => {
		return state.camera.status;
	},
	isCameraHide: state => {
		return state.camera.hide;
	},
	isSearch: state => {
		return state.search.status;
	},
	isResourceCategory: state => {
		return state.resourceCategory.status;
	},
	isSearchHide: state => {
		return state.search.hide;
	},
	isResourceCategoryHide: state => {
		return state.resourceCategory.hide;
	},
	isSearchShow: state => {
		return state.search.show;
	},
	isBackButton: state => {
		return state.button;
	},
	isAcceptDeclineHide: state => {
		return state.acceptDeclineHide;
	},
	isAvailUnavailableHide: state => {
		return state.availUnavailableHide;
	},
	isBookingsConfirmed: state => {
		return state.bookings.confirmed;
	},
	getRouteName: state => {
		return state.route.name;
	},
	getReturnToComp: state => {
		return state.returnToComp;
	},
	getClockOnOffMessage: state => {
		return state.clock.messageArray;
	},
	getIcon: state => {
		return state.icon;
	},
	bookingDetailRefNum: state => {
		return state.bookingDetail.ref_num;
	},
	getJobSessionId: state => {
		return state.bookingDetail.jobSessionId;
	},
	getImageFor: state => {
		return state.imageFor;
	},
	getNoEndDate: state => {
		return state.noEndDate;
	},
	getJob: state => {
		return state.job;
	},
	getStrDateStart(state) {
		return keyword => state.strDate.filter(item => {
			if (item.ref_num == keyword) {

				return item;
			}
		});
	},
	getStrDateEnd(state) {
		return keyword => state.strDate.filter(item => {
			if (item.ref_num == keyword) {
				return item;
			}
		});
	},
	getScrollStatus: state => {
		return state.scrollStatus;
	},
	getClockActivity: state => {
		return state.clockActivity;
	},
	getCallToOffice: state => {
		return state.callToOffice;
	},
	getIntervalVariable: state => {
		return state.intervalVariable;
	},
	getIsInterval: state => {
		return state.isInterval;
	},
	getInter_trans: state => {
		return state.inter_trans;
	},
	getSearchedDate: state => {
		return state.searchedDate;
	},
	getServiceDate: state => {
		return state.serviceDate;
	},
	getServiceStartTime: state => {
		return state.serviceStartTime;
	},
	getServiceEndTime: state => {
		return state.serviceEndTime;
	}
};

export const store = new Vuex.Store({
	state,
	getters,
	actions,
	mutations
});
